/* ============================================================
   BIALETTI SHOPIFY THEME — theme.js
   Vanilla JS — no external dependencies
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initHeaderPosition();
  initMobileMenu();
  initSearch();
  initCart();
  initProductPage();
  initSlideshows();
  initCountdownTimers();
  initFAQ();
  initProductRecommendations();
  initDinamizeNewsletter();
  initProductShelf();
  initVideoProductSpotlight();
  initVideoReels();
  initMegaMenu();
  initProductPageExtras();
  initAutoGift();
});

/* ============================================================
   DINAMIZE NEWSLETTER
   ============================================================ */
function initDinamizeNewsletter() {
  document.querySelectorAll('[data-dinamize-newsletter]').forEach((form) => {
    const iframe = document.getElementById(form.getAttribute('target'));
    const submitButton = form.querySelector('[type="submit"]');
    const successMessage = form.querySelector('[data-newsletter-success]');
    const errorMessage = form.querySelector('[data-newsletter-error]');
    const emailInput = form.elements.cmp1;
    const phoneInput = form.elements.cmp24_NUM;
    if (!iframe || !submitButton) return;

    let submissionPending = false;
    let submissionTimeout;
    const originalButtonText = submitButton.textContent;

    const formatBrazilianPhone = (value) => {
      const digits = value.replace(/\D/g, '').slice(0, 11);
      if (!digits) return '';
      if (digits.length < 3) return `(${digits}`;

      const areaCode = digits.slice(0, 2);
      const number = digits.slice(2);
      const prefixLength = number.length > 8 ? 5 : 4;
      const prefix = number.slice(0, prefixLength);
      const suffix = number.slice(prefixLength);
      return `(${areaCode}) ${prefix}${suffix ? `-${suffix}` : ''}`;
    };

    const validatePhone = () => {
      if (!phoneInput) return true;
      const digits = phoneInput.value.replace(/\D/g, '');
      const isValid = digits.length === 0 || digits.length === 10 || digits.length === 11;
      phoneInput.setCustomValidity(isValid ? '' : 'Informe um telefone com DDD válido.');
      return isValid;
    };

    emailInput?.addEventListener('input', () => emailInput.setCustomValidity(''));
    emailInput?.addEventListener('invalid', () => {
      emailInput.setCustomValidity(emailInput.validity.valueMissing
        ? 'Informe seu e-mail.'
        : 'Informe um e-mail válido.');
    });

    phoneInput?.addEventListener('input', () => {
      phoneInput.value = formatBrazilianPhone(phoneInput.value);
      validatePhone();
    });

    phoneInput?.addEventListener('blur', validatePhone);

    const finishSubmission = (successful) => {
      if (!submissionPending) return;
      submissionPending = false;
      window.clearTimeout(submissionTimeout);
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
      if (successMessage) successMessage.hidden = !successful;
      if (errorMessage) errorMessage.hidden = successful;

      if (successful) {
        form.reset();
        successMessage?.focus();
      }
    };

    form.addEventListener('submit', () => {
      if (emailInput) emailInput.value = emailInput.value.trim();
      if (!validatePhone()) return;

      const phoneDdi = form.elements.cmp24_DDI;
      const phoneNumber = form.elements.cmp24_NUM;
      const phoneValue = form.elements.cmp24;
      const numberDigits = phoneNumber?.value.replace(/\D/g, '') || '';
      if (phoneValue) {
        const ddiDigits = phoneDdi?.value.replace(/\D/g, '') || '';
        phoneValue.value = numberDigits ? `${ddiDigits}${numberDigits}` : '';
      }

      submissionPending = true;
      submitButton.disabled = true;
      submitButton.textContent = 'Enviando...';
      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
      submissionTimeout = window.setTimeout(() => finishSubmission(false), 15000);
    });

    iframe.addEventListener('load', () => finishSubmission(true));
  });
}

/* ============================================================
   STICKY HEADER / ANNOUNCEMENT BAR
   ============================================================ */
function initHeaderPosition() {
  const header = document.querySelector('.header-fixed');
  const announcementBar = document.querySelector('.top-bar');
  if (!header) return;

  const headerMainRow = header.firstElementChild;

  let ticking = false;

  const updateHeaderPosition = () => {
    const barHeight = announcementBar?.offsetHeight || 0;
    const headerHeight = headerMainRow?.offsetHeight || header.offsetHeight;
    const visibleBarHeight = Math.max(0, barHeight - window.scrollY);
    header.style.setProperty('--announcement-bar-visible-height', `${visibleBarHeight}px`);
    document.documentElement.style.setProperty('--header-stack-height', `${barHeight + headerHeight}px`);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderPosition);
  };

  updateHeaderPosition();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
}

/* ============================================================
   MOBILE MENU
   ============================================================ */
function initMobileMenu() {
  const trigger = document.querySelector('#mobile-menu-trigger');
  const menu    = document.querySelector('#mobile-menu');
  if (!trigger || !menu) return;

  const iconMenu = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" x2="21" y1="6" y2="6"/><line x1="3" x2="21" y1="12" y2="12"/><line x1="3" x2="21" y1="18" y2="18"/></svg>`;
  const iconClose = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;

  trigger.addEventListener('click', () => {
    const isOpen = !menu.classList.contains('hidden');
    menu.classList.toggle('hidden');
    trigger.setAttribute('aria-expanded', String(!isOpen));
    trigger.innerHTML = isOpen ? iconMenu : iconClose;
  });
}

/* ============================================================
   SEARCH OVERLAY
   ============================================================ */
function initSearch() {
  const trigger     = document.querySelector('#search-trigger');
  const overlay     = document.querySelector('#search-overlay');
  const input       = document.querySelector('#search-input');
  const pageType    = document.body?.dataset.pageType;
  const pageInput   = document.querySelector('.main-search__input');
  const closeBtn    = document.querySelector('#search-close');
  const iconSearch  = document.querySelector('#icon-search');
  const iconClose   = document.querySelector('#icon-close-search');

  if (!trigger) return;

  if (pageType === 'search' && pageInput) {
    trigger.addEventListener('click', () => {
      pageInput.focus();
      pageInput.select();
      pageInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    return;
  }

  if (!overlay) return;

  const syncSearchOffset = (isOpen) => {
    document.documentElement.style.setProperty('--search-overlay-offset', isOpen ? `${overlay.offsetHeight}px` : '0px');
  };

  const openSearch = () => {
    overlay.style.display = 'block';
    trigger.setAttribute('aria-expanded', 'true');
    if (iconSearch) iconSearch.style.display = 'none';
    if (iconClose)  iconClose.style.display  = 'block';
    syncSearchOffset(true);
    if (input) { input.focus(); input.select(); }
  };

  const closeSearch = () => {
    overlay.style.display = 'none';
    trigger.setAttribute('aria-expanded', 'false');
    if (iconSearch) iconSearch.style.display = 'block';
    if (iconClose)  iconClose.style.display  = 'none';
    syncSearchOffset(false);
  };

  trigger.addEventListener('click', () => {
    const isOpen = overlay.style.display !== 'none' && overlay.style.display !== '';
    isOpen ? closeSearch() : openSearch();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  window.addEventListener('resize', () => {
    const isOpen = overlay.style.display !== 'none' && overlay.style.display !== '';
    syncSearchOffset(isOpen);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeSearch();
  });

  // Close when clicking outside the overlay
  document.addEventListener('click', (e) => {
    if (overlay.style.display === 'none') return;
    if (!overlay.contains(e.target) && e.target !== trigger && !trigger.contains(e.target)) {
      closeSearch();
    }
  });
}

/* ============================================================
   CART DRAWER
   ============================================================ */
function initCart() {
  const cartTrigger = document.querySelector('#cart-icon-bubble');
  const cartDrawer  = document.querySelector('#CartDrawer');
  const cartOverlay = document.querySelector('#CartDrawerOverlay');
  const cartClose   = document.querySelector('#CartDrawerClose');

  if (!cartTrigger || !cartDrawer) return;

  const openCart = () => {
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    // Refresh on open to ensure fresh state
    refreshCartDrawer();
  };

  const closeCart = () => {
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  cartTrigger.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ESC closes drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // Make openCart globally accessible
  window.openCart = openCart;

  // --- Cart Drawer: quantity + remove events ---
  cartDrawer.addEventListener('click', async (e) => {
    const qtyBtn    = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-item-remove]');

    if (qtyBtn) {
      e.preventDefault();
      const itemRow    = qtyBtn.closest('[data-cart-item-key]');
      const itemKey    = itemRow?.dataset.cartItemKey;
      const currentQty = parseInt(itemRow?.querySelector('span')?.textContent || '1');
      const delta      = parseInt(qtyBtn.dataset.qtyDelta || '0');
      const newQty     = Math.max(0, currentQty + delta);
      await updateCartItem(itemKey, newQty);
    }

    if (removeBtn) {
      e.preventDefault();
      const itemRow = removeBtn.closest('[data-cart-item-key]');
      const itemKey = itemRow?.dataset.cartItemKey;
      await updateCartItem(itemKey, 0);
    }

    const discountRemoveBtn = e.target.closest('[data-discount-remove]');
    if (discountRemoveBtn) {
      e.preventDefault();
      await applyDiscountCode('');
    }
  });

  // --- Cart Drawer: discount code form ---
  cartDrawer.addEventListener('submit', async (e) => {
    const form = e.target.closest('#CartDrawerDiscountForm');
    if (!form) return;
    e.preventDefault();

    const input = form.querySelector('#CartDrawerDiscountInput');
    const code  = input?.value.trim();
    if (!code) return;

    await applyDiscountCode(code);
    if (input) input.value = '';
  });

  // --- Full Cart Page: quantity + remove events ---
  const cartPageMain = document.querySelector('#MainContent');
  if (cartPageMain) {
    cartPageMain.addEventListener('click', async (e) => {
      // Skip if inside the drawer
      if (e.target.closest('#CartDrawer')) return;

      const qtyBtn    = e.target.closest('[data-qty-change]');
      const removeBtn = e.target.closest('[data-item-remove]');

      if (qtyBtn) {
        e.preventDefault();
        const itemRow    = qtyBtn.closest('[data-cart-item-key]');
        const itemKey    = itemRow?.dataset.cartItemKey;
        const currentQty = parseInt(itemRow?.querySelector('span')?.textContent || '1');
        const delta      = parseInt(qtyBtn.dataset.qtyDelta || '0');
        const newQty     = Math.max(0, currentQty + delta);
        await updateCartItem(itemKey, newQty, true);
      }

      if (removeBtn) {
        e.preventDefault();
        const itemRow = removeBtn.closest('[data-cart-item-key]');
        const itemKey = itemRow?.dataset.cartItemKey;
        await updateCartItem(itemKey, 0, true);
      }
    });
  }

  // --- Add-to-cart form submit ---
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      const originalText = btn.innerHTML;
      btn.innerHTML = `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>`;

      try {
        const res  = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        const data = await res.json();

        if (!res.ok || data.status === 422) {
          showNotification(data.description || 'Erro ao adicionar ao carrinho', 'error');
        } else {
          await syncAutoGift();
          await refreshCartDrawer();
          openCart();
        }
      } catch {
        showNotification('Erro ao adicionar ao carrinho. Tente novamente.', 'error');
      } finally {
        btn.disabled  = false;
        btn.innerHTML = originalText;
      }
    }
  });
}

/* ============================================================
   BRINDE AUTOMÁTICO
   Adiciona (e remove) automaticamente um produto brinde quando um
   produto com SKU gatilho está no carrinho. Configurado em
   Configurações do tema > Brinde automático.
   ============================================================ */

const AUTO_GIFT_PROPERTY = '_brinde_automatico';
let autoGiftRunning = false;

function getAutoGiftConfig() {
  const config = window.autoGift;
  if (!config || !config.enabled || !config.variantId) return null;

  const triggerSkus = (config.triggerSkus || [])
    .map((sku) => String(sku).trim().toLowerCase())
    .filter(Boolean);
  if (!triggerSkus.length) return null;

  return {
    variantId: Number(config.variantId),
    sku: String(config.sku || '').trim().toLowerCase(),
    triggerSkus,
    removeWhenTriggerGone: config.removeWhenTriggerGone !== false,
  };
}

function isAutoGiftItem(item, config) {
  if (item.id === config.variantId) return true;
  if (config.sku && String(item.sku || '').trim().toLowerCase() === config.sku) return true;
  return Boolean(item.properties && item.properties[AUTO_GIFT_PROPERTY]);
}

/* Reconcile the gift line with the cart. Returns true when the cart changed. */
async function syncAutoGift() {
  const config = getAutoGiftConfig();
  if (!config || autoGiftRunning) return false;

  autoGiftRunning = true;
  try {
    const cart = await (await fetch('/cart.js')).json();
    const items = cart.items || [];

    const giftItem   = items.find((item) => isAutoGiftItem(item, config));
    const hasTrigger = items.some(
      (item) => !isAutoGiftItem(item, config)
        && config.triggerSkus.includes(String(item.sku || '').trim().toLowerCase())
    );

    if (hasTrigger && !giftItem) {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          items: [{
            id:         config.variantId,
            quantity:   1,
            properties: { [AUTO_GIFT_PROPERTY]: 'true' },
          }],
        }),
      });
      return res.ok;
    }

    if (hasTrigger && giftItem && giftItem.quantity !== 1) {
      await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: giftItem.key, quantity: 1 }),
      });
      return true;
    }

    if (!hasTrigger && giftItem && config.removeWhenTriggerGone) {
      await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });
      return true;
    }

    return false;
  } catch {
    return false;
  } finally {
    autoGiftRunning = false;
  }
}

/* Reconcile on page load, for carts changed outside the theme's Ajax handlers. */
async function initAutoGift() {
  if (!getAutoGiftConfig()) return;

  const changed = await syncAutoGift();
  if (!changed) return;

  if (window.location.pathname.includes('/cart')) {
    window.location.reload();
  } else {
    await refreshCartDrawer();
  }
}

/* Update cart item quantity. Pass reloadPage=true to reload after update (cart page). */
async function updateCartItem(key, quantity, reloadPage = false) {
  if (!key) return;
  try {
    const res = await fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity }),
    });
    const cart = await res.json();
    if (!res.ok) throw new Error(cart.description || 'Cart update failed');

    await syncAutoGift();
    syncCartCheckoutState(cart.item_count);

    if (reloadPage) {
      window.location.reload();
    } else {
      await refreshCartDrawer();
    }
  } catch {
    showNotification('Erro ao atualizar o carrinho.', 'error');
  }
}

/* Apply (or remove, when code is '') a discount code on the cart via the Ajax Cart API */
async function applyDiscountCode(code) {
  try {
    const res = await fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ discount: code }),
    });
    const cart = await res.json();
    if (!res.ok) throw new Error(cart.description || 'Não foi possível aplicar o cupom.');

    await refreshCartDrawer();

    if (code) {
      const applied = document.querySelector('#CartDrawerDiscountApplied');
      const found   = applied && applied.textContent.toUpperCase().includes(code.toUpperCase());
      if (!found) showNotification('Cupom inválido ou expirado', 'error');
    }
  } catch (err) {
    showNotification(err.message || 'Erro ao aplicar cupom.', 'error');
  }
}

function syncCartCheckoutState(itemCount) {
  const checkoutButton = document.querySelector('#CartDrawerCheckout');
  if (!checkoutButton) return;

  const isEmpty = Number(itemCount) === 0;
  checkoutButton.classList.toggle('pointer-events-none', isEmpty);
  checkoutButton.classList.toggle('opacity-50', isEmpty);
  checkoutButton.setAttribute('aria-disabled', String(isEmpty));
  if (isEmpty) checkoutButton.setAttribute('tabindex', '-1');
  else checkoutButton.removeAttribute('tabindex');
}

/* Refresh the minicart drawer via Shopify Sections API */
let cartDrawerRefreshId = 0;
async function refreshCartDrawer() {
  const refreshId = ++cartDrawerRefreshId;

  try {
    const res      = await fetch('/?sections=main-cart-drawer', { cache: 'no-store' });
    const sections = await res.json();
    if (refreshId !== cartDrawerRefreshId) return;

    const html     = sections['main-cart-drawer'];
    if (!html) return;

    const parser = new DOMParser();
    const doc    = parser.parseFromString(html, 'text/html');

    const newItemsEl      = doc.querySelector('#CartDrawerItemsAjax');
    const newTotalEl      = doc.querySelector('#CartDrawerTotalAjax');
    const newCountEl      = doc.querySelector('#CartDrawerCountAjax');
    const newCompreJuntoEl = doc.querySelector('#CartDrawerCompreJuntoAjax');
    const newDiscountEl   = doc.querySelector('#CartDrawerDiscountAppliedAjax');

    const itemsTarget      = document.querySelector('#CartDrawerItems');
    const totalTarget      = document.querySelector('#CartDrawerTotal');
    const countBadge       = document.querySelector('[data-cart-count]');
    const compreJuntoTarget = document.querySelector('#CartDrawerCompreJunto');
    const discountTarget   = document.querySelector('#CartDrawerDiscountApplied');

    if (itemsTarget && newItemsEl)             itemsTarget.innerHTML      = newItemsEl.innerHTML;
    if (totalTarget && newTotalEl)             totalTarget.innerHTML      = newTotalEl.innerHTML;
    if (discountTarget && newDiscountEl)       discountTarget.innerHTML   = newDiscountEl.innerHTML;
    if (compreJuntoTarget && newCompreJuntoEl) {
      compreJuntoTarget.innerHTML = newCompreJuntoEl.innerHTML;
      initCompreJuntoSwiper();
    }

    if (countBadge && newCountEl) {
      const count = newCountEl.textContent.trim();
      countBadge.textContent = count;
      countBadge.classList.toggle('hidden', count === '0');
    }

    if (newCountEl) syncCartCheckoutState(newCountEl.textContent.trim());
  } catch {
    // Silently fail — cart will reflect on next page load
  }
}

/* ============================================================
   PRODUCT PAGE
   ============================================================ */
function initProductPage() {
  initThumbnailGallery();
  initQuantityButtons();
  initVariantSelection();
}

function initThumbnailGallery() {
  const mainImage = document.querySelector('#main-product-image');
  const thumbs    = document.querySelectorAll('[data-product-thumbnail]');
  if (!mainImage || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const url = thumb.dataset.imageUrl;
      if (url) mainImage.src = url;
      thumbs.forEach((t) => t.classList.replace('border-foreground', 'border-transparent'));
      thumb.classList.replace('border-transparent', 'border-foreground');
    });
  });
}

function initQuantityButtons() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const input = btn.closest('.qty-group')?.querySelector('input[type="number"]')
               || btn.parentElement?.querySelector('input[type="number"]');
    if (!input) return;
    const delta  = parseInt(btn.dataset.delta || '0');
    const newVal = Math.max(1, parseInt(input.value || '1') + delta);
    input.value  = newVal;
  });
}

function initVariantSelection() {
  const productForm   = document.querySelector('form[action="/cart/add"]');
  const variantDataEl = document.querySelector('#product-json');
  if (!productForm || !variantDataEl) return;

  let variantData;
  try { variantData = JSON.parse(variantDataEl.textContent); }
  catch { return; }

  const variantIdInput = productForm.querySelector('input[name="id"]');
  const priceDisplay   = document.querySelector('#product-price');
  const compareDisplay = document.querySelector('#product-compare-price');
  const compareRow     = document.querySelector('#product-price-compare-row');
  const currentLabel   = document.querySelector('#product-price-current-label');
  const stickyPrice    = document.querySelector('#sticky-price');
  const discountPill   = document.querySelector('#product-discount-pill');
  const addBtn         = productForm.querySelector('[type="submit"]');
  const addText        = addBtn?.dataset.addToCartText || 'Comprar';
  const soldOutText    = addBtn?.dataset.soldOutText || 'Esgotado';
  const cartIcon       = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>`;

  function updateVariant() {
    const selectedOptions = Array.from(
      productForm.querySelectorAll('input[name^="options["]:checked')
    ).map((i) => i.value);
    const totalOptions = Array.isArray(variantData.options) ? variantData.options.length : 0;

    if (selectedOptions.length === 0) return;
    if (totalOptions > 0 && selectedOptions.length !== totalOptions) return;

    const variant = variantData.variants?.find((v) =>
      v.options?.every((opt, idx) => opt === selectedOptions[idx])
    );

    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceDisplay) {
      priceDisplay.textContent = formatMoney(variant.price);
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    const onSale = variant.compare_at_price > variant.price;
    if (compareDisplay) compareDisplay.textContent = formatMoney(variant.compare_at_price || 0);
    if (compareRow) compareRow.classList.toggle('hidden', !onSale);
    if (currentLabel) currentLabel.classList.toggle('hidden', !onSale);
    if (discountPill) {
      if (onSale) {
        const discount = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        discountPill.textContent = `-${discount}%`;
      }
      discountPill.classList.toggle('hidden', !onSale);
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (!variant.available) {
        addBtn.innerHTML = soldOutText;
      } else {
        addBtn.innerHTML = `${cartIcon} ${addText}`;
      }
    }

    // Update URL without reload
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  productForm.addEventListener('change', (e) => {
    if (e.target.name && e.target.name.startsWith('options[')) updateVariant();
  });

  updateVariant();
}

/* ============================================================
   ACCORDIONS
   ============================================================ */
function initAccordions() {
  const triggers = document.querySelectorAll('[data-accordion-trigger]');
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item    = trigger.closest('[data-accordion-item]') || trigger.parentElement;
      const content = item.querySelector('[data-accordion-content]');
      if (!content) return;

      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('[data-accordion-item].open, .accordion-item.open').forEach((el) => {
        el.classList.remove('open');
        const c = el.querySelector('[data-accordion-content]');
        if (c) c.classList.add('hidden');
      });

      // Open clicked (if it was closed)
      if (!isOpen) {
        item.classList.add('open');
        content.classList.remove('hidden');
      }
    });
  });
}

/* ============================================================
   UTILITIES
   ============================================================ */
function formatMoney(cents) {
  return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function showNotification(message, type = 'info') {
  const existing = document.querySelector('.bialetti-notification');
  if (existing) existing.remove();

  const el = document.createElement('div');
  el.className = 'bialetti-notification';
  el.textContent = message;

  const bgColor = type === 'error' ? '#D31515' : '#0f0f0f';
  Object.assign(el.style, {
    position:     'fixed',
    bottom:       '1.5rem',
    left:         '50%',
    transform:    'translateX(-50%)',
    background:   bgColor,
    color:        '#ffffff',
    padding:      '0.75rem 1.5rem',
    borderRadius: '0.25rem',
    fontSize:     '0.875rem',
    fontFamily:   'inherit',
    zIndex:       '9999',
    boxShadow:    '0 4px 12px rgba(0,0,0,0.2)',
    whiteSpace:   'nowrap',
    animation:    'fade-in 0.3s ease',
  });

  document.body.appendChild(el);
  setTimeout(() => el.remove(), 4000);
}

/* ============================================================
   SLIDESHOW
   ============================================================ */
function initSlideshows() {
  document.querySelectorAll('.slideshow').forEach((slideshow) => {
    const slides    = slideshow.querySelectorAll('.slideshow__slide');
    const dots      = slideshow.querySelectorAll('.slideshow__dot');
    const prevBtn   = slideshow.querySelector('.slideshow__arrow--prev');
    const nextBtn   = slideshow.querySelector('.slideshow__arrow--next');
    const autoplay  = slideshow.dataset.autoplay === 'true';
    const speed     = (parseInt(slideshow.dataset.speed, 10) || 5) * 1000;
    let current     = 0;
    let timer       = null;

    if (slides.length <= 1) return;

    const goTo = (index) => {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    };

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); resetTimer(); });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goTo(i); resetTimer(); });
    });

    const resetTimer = () => {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), speed);
    };

    if (autoplay) timer = setInterval(() => goTo(current + 1), speed);
  });
}

/* ============================================================
   COUNTDOWN TIMER
   ============================================================ */
function initCountdownTimers() {
  document.querySelectorAll('.countdown[data-end]').forEach((section) => {
    const endDate    = new Date(section.dataset.end);
    const hideExpired = section.dataset.hideExpired === 'true';
    const expiredEl  = section.querySelector('.countdown__expired');

    if (isNaN(endDate.getTime())) return;

    const update = () => {
      const now  = new Date();
      const diff = endDate - now;

      if (diff <= 0) {
        section.querySelectorAll('[data-unit]').forEach((el) => { el.textContent = '00'; });
        if (expiredEl) expiredEl.style.display = 'block';
        if (hideExpired) section.style.display = 'none';
        clearInterval(timer);
        return;
      }

      const days    = Math.floor(diff / 86400000);
      const hours   = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000)  / 60000);
      const seconds = Math.floor((diff % 60000)    / 1000);

      const pad = (n) => String(n).padStart(2, '0');

      const set = (unit, val) => {
        const el = section.querySelector(`[data-unit="${unit}"]`);
        if (el) el.textContent = pad(val);
      };

      set('days',    days);
      set('hours',   hours);
      set('minutes', minutes);
      set('seconds', seconds);
    };

    update();
    const timer = setInterval(update, 1000);
  });
}

/* ============================================================
   FAQ ACCORDION
   ============================================================ */
function initFAQ() {
  document.querySelectorAll('.faq__trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item    = trigger.closest('.faq__item');
      const answer  = item.querySelector('.faq__answer');
      const isOpen  = item.classList.contains('is-open');

      // Close all items in this FAQ section
      const list = trigger.closest('.faq__list');
      if (list) {
        list.querySelectorAll('.faq__item.is-open').forEach((openItem) => {
          openItem.classList.remove('is-open');
          openItem.querySelector('.faq__trigger').setAttribute('aria-expanded', 'false');
        });
      }

      // Toggle clicked item
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* ============================================================
   PRODUCT RECOMMENDATIONS
   ============================================================ */
function initProductRecommendations() {
  // --- Automatic (API) mode ---
  document.querySelectorAll('[data-source="auto"] .product-recs__auto[data-url]').forEach(async (container) => {
    const url = container.dataset.url;
    if (!url) return;

    const removeEmptySection = () => {
      const section = container.closest('.product-recs');
      if (section) section.remove();
      else container.remove();
    };

    try {
      const res  = await fetch(url);
      if (!res.ok) throw new Error('Recommendations fetch failed');
      const text = await res.text();

      // The response is a full section HTML — extract just the inner grid
      const parser = document.createRange().createContextualFragment(text);
      const inner  = parser.querySelector('.product-recs__grid, .product-recs__track');
      if (inner && inner.children.length > 0) {
        container.innerHTML = '';
        container.appendChild(inner);
      } else {
        removeEmptySection();
      }
    } catch {
      removeEmptySection();
    }
  });

  // --- Carousel (manual) mode with arrow buttons ---
  document.querySelectorAll('[data-source="manual"] .product-recs__track').forEach((track) => {
    const section  = track.closest('[data-section-id]');
    if (!section) return;
    const id       = section.dataset.sectionId;
    const controls = document.getElementById(`product-recs-controls-${id}`);
    const prevBtn  = section.querySelector('.product-recs__arrow--prev');
    const nextBtn  = section.querySelector('.product-recs__arrow--next');
    if (!controls) return;

    // Show controls only when there are more items than visible
    const updateControls = () => {
      const overflowing = track.scrollWidth > track.clientWidth + 4;
      controls.style.display = overflowing ? 'flex' : 'none';
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };

    updateControls();
    window.addEventListener('resize', updateControls);
    track.addEventListener('scroll', updateControls, { passive: true });

    const scrollBy = () => {
      // Scroll by one item width
      const item = track.querySelector('.product-recs__item');
      return item ? item.offsetWidth + 20 : 280;
    };

    if (prevBtn) prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollBy(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollBy(), behavior: 'smooth' });
    });
  });
}

/* ============================================================
   PRODUCT SHELF (Prateleira)
   ============================================================ */
function initProductShelf() {
  document.querySelectorAll('.product-shelf').forEach((shelf) => {
    const id       = shelf.id.replace('product-shelf-', '');
    const prevBtn  = shelf.querySelector('.product-shelf__arrow--prev');
    const nextBtn  = shelf.querySelector('.product-shelf__arrow--next');
    const tabs     = shelf.querySelectorAll('.product-shelf__tab');
    let activeIdx  = 0;

    // --- Card size data attribute (for CSS targeting) ---
    const cardSize = shelf.dataset.cardSize;
    if (!cardSize) {
      // Read from section settings injected via data-card-size on the element
      // (set inline in Liquid via data-card-size="{{ section.settings.card_size }}")
    }

    // --- Active track getter ---
    const getTrack = () => shelf.querySelector(`.product-shelf__panel:not(.product-shelf__panel--hidden) .product-shelf__track`);

    // --- Arrow state update ---
    const updateArrows = () => {
      const track = getTrack();
      if (!track || !prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };

    // --- Scroll amount: one card width ---
    const cardWidth = () => {
      const track = getTrack();
      const item  = track?.querySelector('.product-shelf__item');
      return item ? item.offsetWidth + 20 : 260;
    };

    if (prevBtn) prevBtn.addEventListener('click', () => {
      getTrack()?.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      getTrack()?.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });

    // Listen scroll on all tracks
    shelf.querySelectorAll('.product-shelf__track').forEach((track) => {
      track.addEventListener('scroll', updateArrows, { passive: true });
    });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // --- Tabs ---
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabIdx = parseInt(tab.dataset.tab, 10);
        if (tabIdx === activeIdx) return;

        // Update tabs
        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // Swap panels
        shelf.querySelectorAll('.product-shelf__panel').forEach((panel, i) => {
          panel.classList.toggle('product-shelf__panel--hidden', i !== tabIdx);
        });

        activeIdx = tabIdx;

        // Reset scroll and arrow state on the new panel
        const newTrack = getTrack();
        if (newTrack) newTrack.scrollLeft = 0;
        setTimeout(updateArrows, 50);
      });
    });
  });
}

/* ============================================================
   VIDEO REELS DESKTOP CAROUSEL
   ============================================================ */
function initVideoReels() {
  document.querySelectorAll('.video-reels[data-desktop-carousel="true"]').forEach((section) => {
    const track   = section.querySelector('.video-reels__track');
    const prevBtn = section.querySelector('.video-reels__arrow--prev');
    const nextBtn = section.querySelector('.video-reels__arrow--next');
    if (!track) return;

    const cardWidth = () => {
      const item = track.querySelector('.video-reels__item');
      return item ? item.offsetWidth + 16 : 240;
    };

    const updateArrows = () => {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }));
    if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: cardWidth(), behavior: 'smooth' }));
  });
}

function initVideoProductSpotlight() {
  document.querySelectorAll('.video-product-spotlight').forEach((section) => {
    const track = section.querySelector('.video-product-spotlight__track');
    const items = Array.from(section.querySelectorAll('.video-product-spotlight__item'));
    if (!track || !items.length) return;

    let frameId = null;
    let snapTimer = null;
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let isPointerDown = false;
    let isDragging = false;
    let suppressClick = false;

    const getTrackCenter = () => track.scrollLeft + (track.clientWidth / 2);

    const getItemCenter = (item) => item.offsetLeft + (item.offsetWidth / 2);

    const getCenteredScrollLeft = (item) => {
      const target = getItemCenter(item) - (track.clientWidth / 2);
      const maxScroll = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(target, maxScroll));
    };

    const syncTrackPadding = () => {
      const referenceItem = items[0];
      if (!referenceItem) return;

      const sidePad = Math.max(16, (track.clientWidth - referenceItem.offsetWidth) / 2);
      section.style.setProperty('--video-spotlight-side-pad', `${sidePad}px`);
    };

	    const setActiveCard = () => {
	      const center = getTrackCenter();
	      let activeItem = items[0];
	      let minDistance = Number.POSITIVE_INFINITY;

      items.forEach((item) => {
        const distance = Math.abs(center - getItemCenter(item));

        if (distance < minDistance) {
          minDistance = distance;
          activeItem = item;
        }
      });

	      items.forEach((item) => {
	        item.classList.toggle('is-active', item === activeItem);
	        const selectButton = item.querySelector('.video-product-spotlight__select');
	        if (selectButton) {
	          selectButton.setAttribute('aria-pressed', String(item === activeItem));
	        }
	      });
	    };

    const centerItem = (item, behavior = 'smooth') => {
      track.scrollTo({ left: getCenteredScrollLeft(item), behavior });
    };

    const requestActiveSync = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(() => {
        setActiveCard();
        frameId = null;
      });
    };

    const snapToClosest = (behavior = 'smooth') => {
      const center = getTrackCenter();
      let activeItem = items[0];
      let minDistance = Number.POSITIVE_INFINITY;

      items.forEach((item) => {
        const distance = Math.abs(center - getItemCenter(item));
        if (distance < minDistance) {
          minDistance = distance;
          activeItem = item;
        }
      });

      centerItem(activeItem, behavior);
      setActiveCard();
    };

    const scheduleSnap = () => {
      window.clearTimeout(snapTimer);
      snapTimer = window.setTimeout(() => {
        if (!isDragging) snapToClosest();
      }, 120);
    };

    const endDrag = () => {
      if (!isPointerDown && !isDragging) return;

      isPointerDown = false;
      track.classList.remove('is-dragging');

      if (pointerId !== null && typeof track.releasePointerCapture === 'function') {
        try {
          track.releasePointerCapture(pointerId);
        } catch {}
      }

      pointerId = null;
      if (isDragging) {
        isDragging = false;
        scheduleSnap();
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      }
    };

    const middleIndex = Math.floor(items.length / 2);
    const initialItem = track.querySelector('.video-product-spotlight__item.is-featured') || items[middleIndex] || items[0];

	    track.addEventListener('pointerdown', (event) => {
	      const target = event.target instanceof Element ? event.target : null;
	      if (event.pointerType === 'mouse' && event.button !== 0) return;
	      if (target?.closest('.video-product-spotlight__chip')) return;

	      isPointerDown = true;
	      isDragging = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      window.clearTimeout(snapTimer);

      if (typeof track.setPointerCapture === 'function') {
        try {
          track.setPointerCapture(pointerId);
        } catch {}
      }
    });

    track.addEventListener('pointermove', (event) => {
      if (!isPointerDown) return;

      const deltaX = event.clientX - startX;
      if (!isDragging && Math.abs(deltaX) > 6) {
        isDragging = true;
        suppressClick = true;
        track.classList.add('is-dragging');
      }

      if (!isDragging) return;

      event.preventDefault();
      track.scrollLeft = startScrollLeft - deltaX;
      requestActiveSync();
    });

    track.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);

	    items.forEach((item) => {
	      const selectButton = item.querySelector('.video-product-spotlight__select');
	      const productLink = item.querySelector('.video-product-spotlight__chip');
	      if (!selectButton) return;

	      selectButton.addEventListener('click', (event) => {
	        if (suppressClick) {
	          event.preventDefault();
	          event.stopPropagation();
	          suppressClick = false;
	          return;
	        }

	        if (!item.classList.contains('is-active')) {
	          centerItem(item);
	          return;
	        }

	        if (productLink?.href) {
	          window.location.href = productLink.href;
	        }
	      });
	    });

    track.addEventListener('scroll', () => {
      requestActiveSync();
      if (!isDragging) scheduleSnap();
    }, { passive: true });

    window.addEventListener('resize', () => {
      syncTrackPadding();
      const activeItem = track.querySelector('.video-product-spotlight__item.is-active') || initialItem;
      if (activeItem) centerItem(activeItem, 'auto');
      setActiveCard();
    });

    window.requestAnimationFrame(() => {
      syncTrackPadding();
      centerItem(initialItem, 'auto');
      setActiveCard();
    });
  });
}

/* ============================================================
   MEGA MENU / DROPDOWN NAV
   ============================================================ */
function initMegaMenu() {
  const dropdowns = document.querySelectorAll('.nav-dropdown');

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('.nav-link--has-children');
    if (!trigger) return;

    const open  = () => dropdown.classList.add('is-open');
    const close = () => dropdown.classList.remove('is-open');

    dropdown.addEventListener('mouseenter', open);
    dropdown.addEventListener('mouseleave', close);

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      dropdown.classList.toggle('is-open');
    });
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-dropdown')) {
      dropdowns.forEach((d) => d.classList.remove('is-open'));
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') dropdowns.forEach((d) => d.classList.remove('is-open'));
  });

  // Mobile sub-menus
  document.querySelectorAll('.mobile-nav__trigger').forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent   = btn.closest('.mobile-nav__parent');
      const children = parent.querySelector('.mobile-nav__children');
      const isOpen   = parent.classList.contains('is-open');
      parent.classList.toggle('is-open', !isOpen);
      children.classList.toggle('hidden', isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}

/* ============================================================
   PRODUCT PAGE EXTRAS
   ============================================================ */
function initProductPageExtras() {
  // --- Thumbnail gallery ---
  const mainImg  = document.getElementById('main-product-image');
  const thumbs   = document.querySelectorAll('[data-product-thumbnail]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (mainImg) mainImg.src = thumb.dataset.imageUrl;
      thumbs.forEach((t) => t.classList.remove('main-product__thumb--active'));
      thumb.classList.add('main-product__thumb--active');
    });
  });

  // --- Image lightbox ---
  const trigger  = document.getElementById('product-lightbox-trigger');
  const lightbox = document.getElementById('product-lightbox');
  const lbImg    = document.getElementById('lightbox-img');
  const lbClose  = document.getElementById('product-lightbox-close');

  if (trigger && lightbox && lbImg) {
    const openLightbox = () => {
      lbImg.src = document.querySelector('[data-product-thumbnail].main-product__thumb--active')?.dataset.imageFull
        || mainImg?.src || '';
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };
    const closeLightbox = () => {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', openLightbox);
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && lightbox.style.display !== 'none') closeLightbox(); });
  }

  // --- Sticky mobile bar ---
  const stickyBar = document.getElementById('product-sticky-bar');
  const addBtn    = document.getElementById('product-add-btn');

  if (stickyBar && addBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', String(entry.isIntersecting));
      },
      { rootMargin: '-80px 0px 0px 0px' }
    );
    observer.observe(addBtn);
  }

  // --- Description read more ---
  const desc   = document.getElementById('product-description');
  const toggle = document.getElementById('product-desc-toggle');
  if (desc && toggle) {
    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      desc.classList.toggle('is-expanded', !isExpanded);
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      toggle.querySelector('span') && (toggle.querySelector('span').textContent = isExpanded ? 'Ler mais' : 'Ler menos');
    });
  }

  // --- Copy link ---
  const copyBtn = document.getElementById('copy-product-link');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const url = copyBtn.dataset.url || window.location.href;
      navigator.clipboard?.writeText(url).then(() => {
        const span = copyBtn.querySelector('span');
        if (span) { const orig = span.textContent; span.textContent = 'Copiado!'; setTimeout(() => (span.textContent = orig), 2000); }
      });
    });
  }

  // --- Size guide modal ---
  const sizeGuideBtn   = document.getElementById('size-guide-btn');
  const sizeGuideModal = document.getElementById('size-guide-modal');
  const sizeGuideClose = document.getElementById('size-guide-close');

  if (sizeGuideBtn && sizeGuideModal) {
    sizeGuideBtn.addEventListener('click', () => { sizeGuideModal.style.display = 'flex'; document.body.style.overflow = 'hidden'; });
    if (sizeGuideClose) sizeGuideClose.addEventListener('click', () => { sizeGuideModal.style.display = 'none'; document.body.style.overflow = ''; });
    sizeGuideModal.addEventListener('click', (e) => { if (e.target === sizeGuideModal) { sizeGuideModal.style.display = 'none'; document.body.style.overflow = ''; } });
  }

  document.querySelectorAll('[data-smooth-anchor]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = target.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });
  });
}

/* ============================================================
   COLLECTION DESCRIPTION TOGGLE
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.collection-desc__toggle');
  const body   = document.querySelector('.collection-desc__body');
  const fade   = document.querySelector('.collection-desc__fade');
  if (!toggle || !body) return;

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    body.classList.toggle('is-expanded', !expanded);
    if (fade) fade.classList.toggle('is-hidden', !expanded);
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = expanded ? 'Ver mais' : 'Ver menos';
  });
});

/* ============================================================
   COMPRE JUNTO SWIPER
   ============================================================ */
let compreJuntoSwiperInstance = null;

function initCompreJuntoSwiper() {
  if (compreJuntoSwiperInstance) {
    compreJuntoSwiperInstance.destroy(true, true);
    compreJuntoSwiperInstance = null;
  }

  const el = document.querySelector('.compre-junto-swiper');
  if (!el || typeof Swiper === 'undefined') return;

  compreJuntoSwiperInstance = new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 12,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.compre-junto-pagination',
      clickable: true,
    },
  });
}
